<template>
    <div id="app" :class="{ 'l-container': $env === 'development' }">
        <router-view />
    </div>
</template>

<script>
import { setup } from "@/mixins/setup";
import { baseTitle, baseDescription } from "@/utils/seo";

export default {
    mixins: [setup],
    metaInfo() {
        return {
            titleTemplate: (chunk) => (chunk ? `${chunk} – ${baseTitle}` : baseTitle),
            meta: [
                { vmid: "description", name: "description", content: baseDescription },
                { vmid: "og:title", property: "og:title", content: baseTitle },
                { vmid: "og:description", property: "og:description", content: baseDescription },
            ],
        };
    },
};
</script>

<style lang="scss">
// #app {
//     font-family: "Avenir", Helvetica, Arial, sans-serif;
//     -webkit-font-smoothing: antialiased;
//     -moz-osx-font-smoothing: grayscale;
//     // text-align: center;
//     color: #2c3e50;
// }
</style>
